import styled from "@emotion/styled";
import {
  ActionIcon,
  type ActionIconProps,
  createPolymorphicComponent,
  Flex,
  type FlexProps,
} from "@mantine/core";

const _StyledYachtSetUpItem = styled(Flex)`
  width: 60%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.settingsColor};
  color: ${({ theme }) => theme.colors.settingsColor};
  cursor: default;
  gap: 20px;
  transition: background-color 0.3s;
  &:hover {
    background-color: ${({ theme }) => theme.colors.selectItemHoverBg};
    color: white;
  }
`;

export const StyledYachtSetUpItem = createPolymorphicComponent<
  "div",
  FlexProps
>(_StyledYachtSetUpItem);

const _StyledRemoveActionIcon = styled(ActionIcon)`
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  &:hover {
    color: #e03131;
    background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  }
`;

export const StyledRemoveActionIcon = createPolymorphicComponent<
  "button",
  ActionIconProps
>(_StyledRemoveActionIcon);
